import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import PropTypes from 'prop-types';
import React from 'react';
import { ComponentsProvider, DISPLAYS_NAMESPACE } from '@panneau/core/contexts';
import displayActions from '@panneau/display-actions';
import displayAvatar from '@panneau/display-avatar';
import displayText from '@panneau/display-text';
import displayTextLocalized from '@panneau/display-text-localized';
import displayTextDescription from '@panneau/display-text-description';
import displayBoolean from '@panneau/display-boolean';
import displayImage from '@panneau/display-image';
import displayLabel from '@panneau/display-label';
import displayLink from '@panneau/display-link';
import displaySelect from '@panneau/display-select';
import displayDate from '@panneau/display-date';
import displayBadges from '@panneau/display-badges';
import displayUnit from '@panneau/display-unit';

var components = /*#__PURE__*/Object.freeze({
    __proto__: null,
    Actions: displayActions,
    Avatar: displayAvatar,
    Badges: displayBadges,
    Boolean: displayBoolean,
    Date: displayDate,
    Image: displayImage,
    Label: displayLabel,
    Link: displayLink,
    Select: displaySelect,
    Text: displayText,
    TextDescription: displayTextDescription,
    TextLocalized: displayTextLocalized,
    Unit: displayUnit
});

var _excluded = ["components", "children"];
var propTypes = {
  components: PropTypes.object,
  // eslint-disable-line
  children: PropTypes.node
};
var defaultProps = {
  components: null,
  children: null
};
var DisplaysProvider = function DisplaysProvider(_ref) {
  var injectedComponents = _ref.components,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(ComponentsProvider, Object.assign({
    namespace: DISPLAYS_NAMESPACE,
    components: _objectSpread(_objectSpread({}, components), injectedComponents)
  }, props), children);
};
DisplaysProvider.propTypes = propTypes;
DisplaysProvider.defaultProps = defaultProps;

export { DisplaysProvider as default };
